/**
 * Converts URLs in text to clickable links
 */

// URL regex pattern - matches http, https, and www URLs
const urlPattern = /(https?:\/\/[^\s<]+[^<.,:;"')\]\s]|www\.[^\s<]+[^<.,:;"')\]\s])/gi;

/**
 * Linkify text - converts URLs to clickable anchor tags
 * @param {string} text - The text to process
 * @param {boolean} isMyMessage - Whether this is the current user's message (for styling)
 * @returns {Array} - Array of React elements (text and links)
 */
export function linkifyText(text, isMyMessage = false) {
  if (!text) return text;
  
  const parts = [];
  let lastIndex = 0;
  let match;
  
  // Reset regex lastIndex
  urlPattern.lastIndex = 0;
  
  while ((match = urlPattern.exec(text)) !== null) {
    // Add text before the URL
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    
    // Add the URL as a link
    let url = match[0];
    let href = url;
    
    // Add protocol if missing
    if (url.startsWith('www.')) {
      href = 'https://' + url;
    }
    
    parts.push({
      type: 'link',
      url: url,
      href: href,
      isMyMessage: isMyMessage
    });
    
    lastIndex = match.index + match[0].length;
  }
  
  // Add remaining text after last URL
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  
  // If no URLs found, return original text
  if (parts.length === 0) {
    return [text];
  }
  
  return parts;
}

/**
 * Check if text contains any URLs
 * @param {string} text - The text to check
 * @returns {boolean} - Whether the text contains URLs
 */
export function containsUrl(text) {
  if (!text) return false;
  urlPattern.lastIndex = 0;
  return urlPattern.test(text);
}
